import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/Australia.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/career/main-image-UPDATED.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/career/Pic-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/career/Pic2.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/career/Pic5.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us/sustainability/environmental/Values-01.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/Google-5-star.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/Half-heart-element.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/hearts/half-heart-with-tag-line.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/NDIS/NDIS-Registered-Provider-white-text.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/pageSpecific/about/quoteImageSlider.tsx");
